import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.108 1.5c-1.718 0-3.154 1.364-3.154 3.1s1.436 3.098 3.154 3.098S14.26 6.335 14.26 4.6c0-1.735-1.436-3.099-3.153-3.099m3.655 8.957a2.809 2.809 0 0 0-5.353 1.699l1.19 4.06.014.042a2.77 2.77 0 0 0 1.583 1.701c.55.23 1.021.235 1.085.235h.849a1 1 0 0 1 .967.746l.05.193h-4.465a1 1 0 0 1-.97-.759l-1.92-7.719a1 1 0 1 0-1.94.483l1.919 7.719a3 3 0 0 0 2.911 2.276h5.095c.719 1.235 2.059 1.62 3.18 1.329 1.237-.321 2.306-1.51 1.967-3.163l-.004-.016-.894-3.728a3 3 0 0 0-2.917-2.3h-1.39zM3 2a1 1 0 0 0 0 2h1.246l.792 2.775a1 1 0 1 0 1.924-.55l-1-3.5A1 1 0 0 0 5 2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_seat_filled-_WevEl3L.js.map
